import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Toolbar from '@material-ui/core/Toolbar'
import Colors from '~shared/assets/styles/colors'
import FooterItem from '~components/atoms/FooterItem'
import classNames from 'classnames'

const components = {
  FooterItem,
}

const styles = ({ breakpoints, spacing: { unit } }) => ({
  bar: {
    backgroundColor: Colors.MiddleGrey,
    [breakpoints.down('sm')]: {
      textAlign: 'center',
    },
    padding: '14px 40px',
    borderTop: '1px solid rgba(0, 0, 0, 0.05)',
    minHeight: 'auto',

    [breakpoints.down('xs')]: {
      padding: '0px 25px 25px',
      borderTop: '0px',
    },
  },
  width: {
    maxWidth: '1440px',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    overflow: 'hidden',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',

    [breakpoints.down('md')]: {
      justifyContent: 'flex-start',
    },
    [breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      flexDirection: 'column-reverse',
    },
  },
  copyright: {
    margin: 0,

    fontFamily: 'Roboto, sans-serif',
    letterSpacing: '-0.08px',
    fontWeight: 400,

    color: Colors.NewGrey,
    fontSize: '10px',
    lineHeight: '12px',
    marginRight: '50px',
    '&:last-child': {
      marginRight: '0px',
    },

    [breakpoints.down('md')]: {
      marginRight: '50px',
      '&:last-child': {
        marginRight: '0px',
      },
    },
    [breakpoints.down('sm')]: {
      fontSize: '8px',
      marginRight: '4px',
      whiteSpace: 'nowrap',
      '&:last-child': {
        marginBottom: 0,
      },
    },

    '& > a': {
      color: Colors.NewGrey,
      textDecoration: 'underline',
    },
  },
  copyrightCaptcha: {
    [breakpoints.down('sm')]: {
      fontSize: '8px',
      whiteSpace: 'pre-wrap',
      textAlign: 'start',
    },
  },
  rightItem: {
    color: Colors.White,
    [breakpoints.down('xs')]: {
      '&:last-child': {
        marginBottom: unit,
      },
    },
  },
  content: {
    flexBasis: 'auto',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    rowGap: '10px',

    [breakpoints.down('md')]: {
      justifyContent: 'center',
    },
    [breakpoints.down('xs')]: {
      justifyContent: 'flex-start',
      boxSizing: 'border-box',
      gap: '0px',
    },
  },

  paddingBottomXs: {
    [breakpoints.down('xs')]: {
      paddingBottom: '85px',
    },
  },
})

const Footer = withStyles(styles)(
  class Footer extends React.Component {
    render() {
      const {
        classes,
        className,
        style,
        data: { items = [] },
        captchaBrandingVisibility,
        isDashboard,
        labels,
      } = this.props
      return (
        <Toolbar
          disableGutters
          className={classNames(className, classes.bar, { [classes.paddingBottomXs]: isDashboard })}
          style={style}
        >
          <div className={classes.width}>
            <div className={classes.container}>
              <div className={classes.content}>
                <p className={classes.copyright}>{labels.FOOTER_COPYRIGHT}</p>
                <p className={classes.copyright}>{labels.FOOTER_OWNER}</p>
                <p className={classNames(classes.copyright, classes.copyrightCaptcha)}>
                  This site is protected by reCAPTCHA and the Google.{' '}
                  <a
                    href="https://policies.google.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>{' '}
                  and{' '}
                  <a
                    href="https://policies.google.com/terms"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms of Service
                  </a>{' '}
                  apply.
                </p>
                <p className={classes.copyright}>{labels.FOOTER_ADDRESS}</p>
                <p className={classes.copyright}>
                  <a href="mailto:info@jti-partner.ru">{labels.FOOTER_EMAIL}</a>
                </p>
              </div>
            </div>
          </div>
        </Toolbar>
      )
    }
  },
)

export default Footer
